/** @format */

import {SensorGroupColorType} from 'types';

export const COLOR_TYPES: SensorGroupColorType[] = ['RED', 'YELLOW', 'GRAY'];
